import { bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
// import { ClientInfoService } from '@app/core/services/client-info.service';
import { CLIENT_INFO } from '@app/core/tokens/client-info.token';
import { DeviceDetectionService } from '@app/core/services/device-detection.service';
import { environment } from '@environments/environment';

const script = document.createElement('script');
script.src = environment.app.adobeAnalyticsUrl;
document.head.appendChild(script);
const code = document.createElement('script');
code.innerHTML = `var adobeDataLayer=  adobeDataLayer|| [];`
document.head.appendChild(code);
const scriptNewRelic = document.createElement('script');
scriptNewRelic.src = environment.app.newRelicUrl;
scriptNewRelic.type = "text/javascript";
document.head.appendChild(scriptNewRelic);

function deviceInfoInitializer(svc: DeviceDetectionService) {
  return async () => {
    await svc.detect();
  };
}


bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideHttpClient(),
    provideAnimations(),
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),

    DeviceDetectionService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: deviceInfoInitializer,
      deps: [DeviceDetectionService],
    },
    {
      provide: CLIENT_INFO,
      useFactory: (svc: DeviceDetectionService) => svc.getCached(),
      deps: [DeviceDetectionService],
    },

  ]
})
  .catch((err) => console.error(err));
